import Aboutus from './routes/content/Aboutus.vue';
import createAboutus from './routes/content/component/createAboutus.vue';
import editAboutus from './routes/content/component/editAboutus.vue';

import editBannerAboutUs from './routes/banner/Banner.vue';

const aboutUsRoutes = [
    {
        path: '/about-us',
        name: 'Aboutus',
        component: Aboutus,
      },
      {
        path: '/create-about-us',
        name: 'createAboutus',
        component: createAboutus,
      },
      {
        path: '/edit-about-us/:id',
        name: 'editAboutus',
        component: editAboutus,
      },
      {
        path: '/banner-about-us',
        name: 'editBannerAboutUs',
        component: editBannerAboutUs,
      },
];

export default aboutUsRoutes;
